<template>
  <v-card class="mx-auto" elevation="0">
    <v-card-title class="card-header fixed-card-title">
      {{ $t('add-patient') }}
      <v-spacer></v-spacer>
      <v-icon class="white-color" @click="closeDrawer">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="px-2 py-16">
      <v-form ref="form" lazy-validation>
        <v-container>
          <v-row dense>
            <v-col cols="6">
              <!-- Name -->
              <v-text-field outlined hide-details dense v-model="userDetails.firstName"
                :rules="[v => !!v || 'Item is required']" :label="$t('name')" required></v-text-field>
            </v-col>
            <v-col cols="6">
              <!-- Surname -->
              <v-text-field outlined :rules="[v => !!v || 'Item is required']" hide-details dense
                v-model="userDetails.lastName" :label="$t('surname')" required></v-text-field>
            </v-col>
            <v-col cols="6">
              <!-- Birthday -->
              <BirthdatePicker :inputValue.sync="birthdate" />
            </v-col>
            <v-col cols="6">
              <!-- Gender -->
              <v-select outlined hide-details dense :label="$t('gender')" :items="patients.gender"
                v-model="userDetails.gender" :menu-props="{ offsetY: true }">
                <template v-slot:item="{ item }">
                  {{ item.text }}
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <!-- Prescribing doctor -->
              <v-select outlined dense v-model="prescribingDoctor" :label="$t('prescribing-doctor')" :items="doctors"
                return-object :item-text="(a) => a.firstName + ' ' + a.lastName" item-value="id"
                :menu-props="{ maxHeight: 200, offsetY: true }" hide-details />
            </v-col>
            <!-- Select location dropdown -->
            <v-col cols="12">
              <v-select outlined hide-details dense :label="$t('select-location')"
                :items="userData.hospitalsAssignedData" item-text="hospitalName" return-object
                v-model="selectedLocation" @change="onLocationSelect">
                <template v-slot:item="{ item }">
                  {{ item.hospitalName }}
                </template>
              </v-select>
            </v-col>

          </v-row>

          <v-row dense>
            <!-- Address -->
            <v-col cols="12">
              <v-text-field ref="address" v-model="patientAddress" :label="$t('address')" outlined hide-details dense disabled>
              </v-text-field>
            </v-col>
            <!-- City -->
            <v-col class="pa-1" cols="6">
              <v-text-field outlined hide-details dense :label="$t('city')" v-model="addressInfo.city" required disabled></v-text-field>
            </v-col>
            <!-- State -->
            <v-col class="pa-1" cols="6">
              <v-text-field outlined hide-details dense :label="$t('state')" v-model="addressInfo.state" required disabled></v-text-field>
            </v-col>
            <!-- Zip -->
            <v-col class="pa-1" cols="6">
              <v-text-field outlined hide-details dense :label="$t('zip')" v-model="addressInfo.zip" required disabled></v-text-field>
            </v-col>
            <!-- Country -->
            <v-col class="pa-1" cols="6">
              <v-text-field outlined hide-details dense :label="$t('country')" v-model="addressInfo.country" required disabled></v-text-field>

            </v-col>
          </v-row>

          <v-row v-if="!addressIsValid" dense>
            <v-col cols="12">
              <v-combobox :label="$t('time-zone')" dense hide-details="auto" outlined
                :rules="[v => !!v || $t('timeZoneSelect')]" v-model="timezone" item-text="timeZoneId"
                item-value="timeZoneId" :items="getTimeZone" required></v-combobox>
            </v-col>
          </v-row>

          <!-- RPM RTM CCM -->
          <v-row id="PatientTypeButtons" class="mb-3 px-2 justify-center" v-if="
                userData.isSequoiaUser === true || roleName === 'HOSPITAL_ADMIN'
              ">
            <v-col class="pa-1" cols="4" sm="4">
              <div>
                <span class="font-weight-bold color-black">{{
                  $t("enable-rpm")
                }}</span>
                <v-btn-toggle v-model="enableRPM" row active-class="chips white--text" mandatory class="white">
                  <v-btn class="tabs-class" :value="true" :input-value="enableRPM" style="max-width: 50%">
                    {{ $t("yes") }}
                  </v-btn>
                  <v-btn class="tabs-class" :value="false" :input-value="enableRPM" style="max-width: 50%">
                    {{ $t("no") }}
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col class="pa-1" cols="4" sm="4">
              <div>
                <span class="font-weight-bold color-black">{{
                  $t("enable-rtm")
                }}</span>
                <v-btn-toggle v-model="enableRTM" row active-class="chips white--text" mandatory class="white">
                  <v-btn class="tabs-class" :value="true" :input-value="enableRTM" style="max-width: 50%">
                    {{ $t("yes") }}
                  </v-btn>
                  <v-btn class="tabs-class" :value="false" :input-value="enableRTM" style="max-width: 50%">
                    {{ $t("no") }}
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col class="pa-1" cols="4" sm="4">
             <div>
                <span class="font-weight-bold color-black">{{
                  $t("enable-ccm")
                }}</span>
                <v-btn-toggle v-model="enableCCM" row active-class="chips white--text" mandatory class="white">
                  <v-btn class="tabs-class" :value="true" :input-value="enableCCM" style="max-width: 50%">
                    {{ $t("yes") }}
                  </v-btn>
                  <v-btn class="tabs-class" :value="false" :input-value="enableCCM" style="max-width: 50%">
                    {{ $t("no") }}
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions class="fixed-card-actions">
      <v-row dense class="pa-0">
        <v-col cols="6">
          <v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn @click="loader = 'loading'" :disabled="isSaveButtonDisabled" class="save-button-style">
            {{ $t('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BirthdatePicker from '@/views/Client/components/BirthdatePicker.vue';
import { showErrorAlert, showSuccessAlert } from '@/utils/utilities';

export default {
  name: 'DashboardCoreAppBar',
  components: {
    BirthdatePicker,
  },
  data: () => ({
    addressIsValid: true,
    userDetails: {
      firstName: '',
      lastName: '',
      email: 'generic@wellnessmetric.net',
    },
    dataStatus: null,
    loader: null,
    loading: null,
    staffSelected: [],
    patientAddress: '',
    validationErrors: [],
    addressInfo: {
      address: '',
      zip: '',
      city: '',
      state: '',
      country: '',
      lat: 32.798718741846955,
      lng: -96.79917112574036,
    },
    smoker: '0',
    heightInCm: null,
    birthdate: '',
    weightInKg: null,
    tab: null,
    userDetailsPolicyNumber: '',
    emailError: false,
    scaleAndTempUnit: 'IMPERIAL',
    glucoseAndCholesterolUnit: 'mg/dl',
    patients: {
      gender: [{ text: 'Male', value: 1 }, { text: 'Female', value: 2 }],
    },
    phone: '+1 234 567 8900',
    timezone: null,
    enableRTM: false,
    enableRPM: false,
    enableCCM: false,
    selectedLocation: {},
    toggle: [],
    doctors: [],
    prescribingDoctor: null,
  }),
  computed: {
    ...mapState({
      userData: (state) => state.authentication.userData,
      detailedUser: (state) => state.users.detailedUser,
      detailsDrawer: (state) => state.detailsDrawer,
    }),
    ...mapGetters({
      roleName: 'authentication/getRole',
      userSettings: 'authentication/getUserSettings',
      getDoctorAndNurse: 'hospitals/getDoctorAndNurse',
      getTimeZone: 'verifiers/getTimeZone',
    }),
    dataTableHeight () {
      if (this.$vuetify.breakpoint.width <= 1200 && this.$vuetify.breakpoint.height <= 802) {
        return 200;
      } else if (this.$vuetify.breakpoint.width <= 2560 && this.$vuetify.breakpoint.height <= 1305) {
        return 465;
      } else {
        return 200;
      }
    },
    genderValue () {
      if (this.userDetails.gender === 1) {
        return 'M';
      } else if (this.userDetails.gender === 2) {
        return 'F';
      }
      return null;
    },
    isSaveButtonDisabled () {
      return false;
    },
    headers () {
      const headers = [
        { text: '', sortable: false },
        { text: this.$t('name'), sortable: false, align: 'start' },
        { text: this.$t('description'), sortable: false, align: 'start' },
      ];
      return headers;
    },
    headers2 () {
      const headersMedicalTeam = [
        { text: this.$t('name'), sortable: false, align: 'start' },
        { text: '', sortable: false, align: 'start' },
        { text: '', sortable: false, align: 'start' },
      ];
      return headersMedicalTeam;
    },
    tabsHeader () {
      return [
        { title: this.$t('treatments'), content: '' },
        { title: this.$t('allergies'), content: '' },
        { title: this.$t('diagnoses'), content: '' },
        // { title: this.$t('problem-list'), content: '' },
      ];
    },
  },
  async mounted () {
    await this.initializeAddPatient();
    this.getSelectedLocation();
    this.getStaff();
    this.getMedicalTeams();
  },
  methods: {
    async getMedicalTeams () {
      const currentHospital = localStorage.getItem('selectedHospitalAssignedId');
      await this.$store.dispatch('hospitals/getRelatedMedicalStaffForHospital', Number(currentHospital));
      this.doctors = this.getDoctorAndNurse.filter(d => d.status === 1 && d.roleId === 3);
      this.staffSelected = this.getDoctorAndNurse.map(d => d.id);
      this.loading = false;
    },
    async getStaff () {
      await this.$store.dispatch('hospitals/getRelatedMedicalStaffForHospital', this.userData.hospitalAssignedData.id);
    },
    getSelectedLocation () {
      var selectedHospitalId = localStorage.getItem('selectedHospitalAssignedId');
      this.selectedLocation = this.userData.hospitalsAssignedData.find(it => it.id === Number(selectedHospitalId));
    },
    onLocationSelect (selected) {
      this.selectedLocation = selected;
      this.patientAddress = selected.address;
      this.addressInfo.city = selected.city;
      this.addressInfo.state = selected.state;

      this.addressInfo.zip = selected.zip;
      this.addressInfo.country = selected.country;
    },
    async initializeAddPatient () {
      this.checkAndFixLocationDetails();
      this.getStaff();
      // this.checkValid();
      this.dataStatus = this?.userData?.patientMetadata?.isManualMeasurement;
    },
    checkAndFixLocationDetails () {
      this.addressInfo.address = this.userData.hospitalAssignedData.address;

      this.patientAddress = this.userData.hospitalAssignedData.address;
      this.addressInfo.city = this.userData.hospitalAssignedData.city;
      this.addressInfo.state = this.userData.hospitalAssignedData.state;
      this.addressInfo.zip = this.userData.hospitalAssignedData.zip;
      this.addressInfo.country = this.userData.hospitalAssignedData.country;
      if (this.userData.hospitalAssignedData.addressLatitude !== 0.01 && this.userData.hospitalAssignedData.addressLongitude !== 0.01 && this.userData.hospitalAssignedData.addressLongitude !== null && this.userData.hospitalAssignedData.addressLatitude !== null) {
        // TODO there is good address call  edpoint for geting the correct time zone with given lan lng

        const latLng = {
          lat: this.userData.hospitalAssignedData.addressLatitude,
          lng: this.userData.hospitalAssignedData.addressLongitude,
        };

        this.$store.dispatch(
          'googleAPI/getTimeZone',
          latLng,
        ).then(response => {
          this.timezone = response.zoneName;
          this.addressInfo.lat = this.userData.hospitalAssignedData.addressLatitude;
          this.addressInfo.lng = this.userData.hospitalAssignedData.addressLongitude;
          this.addressIsValid = true;
        });
      } else {
        // TODO There is bad address show time zoene lookup
        this.addressInfo.lat = 0.01;
        this.addressInfo.lng = 0.01;
        this.addressIsValid = false;
      }
    },
    resetComponent () {
      this.userDetails.firstName = '';
      this.userDetails.lastName = '';
      this.userDetails.email = '';
      this.userDetails.gender = '';
      this.userDetailsPolicyNumber = '';
      this.tabsHeader.find(tab => tab.title === this.$t('treatments')).content = '';
      this.tabsHeader.find(tab => tab.title === this.$t('allergies')).content = '';
      this.timezone = '';
      this.prescribingDoctor = null;
    },
    async manageMedicalTeam (res) {
      if (this.prescribingDoctor !== null) {
        const body = {
          hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
          patientId: res.id,
          primaryDoctorId: this.prescribingDoctor.id,
          medicalTeamTitle: res.firstName + ' ' + res.lastName + ' Team',
          medicalTeamDescription: res.firstName + ' ' + res.lastName,
          status: 1,
        };
        await this.$store
          .dispatch('medicalteam/createMedicalTeam', body)
          .then((res) => {
            const createdMedicalTeamId = res.id;
            this.assignMemberToMedicalTeam(createdMedicalTeamId);
          });
      } else {
        const body = {
				hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
          patientId: res.id,
          medicalTeamTitle: res.firstName + ' ' + res.lastName + ' Team',
          medicalTeamDescription: res.firstName + ' ' + res.lastName,
          status: 1,
        };
        await this.$store
          .dispatch('medicalteam/createMedicalTeam', body);
        }
    },
    async assignMemberToMedicalTeam (medicalTeamId) {
      const bodyAssign = {
        medicalTeamId: medicalTeamId,
        memberUserIdList: this.staffSelected,
      };
      await this.$store.dispatch('medicalteam/assignMultipleMembersToMedicalTeam', bodyAssign);
      this.$emit('false');
    },
    getPreferences () {
      const preferences = {
        Units: this.scaleAndTempUnit,
        Concentration: this.glucoseAndCholesterolUnit,
      };
      return preferences;
    },
    async createPatient () {
      if (this.userDetails.firstName.length === 0 ||
        this.userDetails.lastName.length === 0 ||
        this.birthdate.length === 0 ||
        this.genderValue.length === 0
      ) {
        showErrorAlert(this.$t('fill-all-fields-warning'));
        return;
      }

      const bodyForPatientCreate = {
        firstName: this.userDetails.firstName,
        lastName: this.userDetails.lastName,
        phone: '+1 234 567 8900',
        email: this.userDetails.email,
        address: this.addressInfo.address,
        zip: this.addressInfo.zip,
        city: this.addressInfo.city,
        state: this.addressInfo.state,
        country: this.addressInfo.country,
        addressLatitude: this.addressInfo.lat,
        addressLongitude: this.addressInfo.lng,
        username: this.userDetails.email,
        gender: this.genderValue,
        birthdate: this.birthdate,
        roleId: 5, // PATIENT
        language: this.userDetails.language,
        userTimezone: this.addressIsValid ? this.timezone : this.timezone.timeZoneId,
        userSettingsJson: JSON.stringify(this.getPreferences()),
        IsManualMeasurement: this.dataStatus,
				hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
        isEmailAccountProvided: false, // !this.isGenericEmailAccount,
        isRpmEnabled: this.enableRPM,
        isRtmEnabled: this.enableRTM,
        isCcmEnabled: this.enableCCM,
        healthInsurance: 0,
      };

      await this.$store.dispatch('users/createUser', bodyForPatientCreate).then(async (res) => {
        if (res.resFlag === true) {
          // handle patient metadata
          const metaDataBody = {
            userId: res.data.id,
            heightInCm: 0.0,
            weightInKg: 0.0,
            ssn: '',
            medicalRegistrationNumber: '',
            healthInsurance: 0,
            memberIdPolicyNumber: '',
            isCigaretteSmoker: false,
            alcoolConsumtion: 0,
            prescriptions: '',
            metadataInfo: '',
            isManualMeasurement: false,
          };
          await this.$store.dispatch('patientmetadata/editPatientMetaData', metaDataBody);

          // handle medical team
          await this.manageMedicalTeam(res.data);

          const requestSetStatus = {
            userId: res.data.id,
            statusValueToSet: res.data.status,
          };
          await this.$store.dispatch('users/setUserStatus', requestSetStatus);

          showSuccessAlert(this.$t('successfully-created-patient'));

          await this.getPatients(); // refresh the patients list
          this.resetComponent();
          this.closeDrawer();
        } else {
          showErrorAlert(res.msg);
        }
      });
    },
    closeDrawer () {
      this.userDetails.firstName = '';
      this.userDetails.lastName = '';
      this.userDetails.mrn = '';
      this.userDetails.email = '';
      this.phone = '+1 234 567 8900';
      this.addressInfo.lat = null;
      this.addressInfo.lng = null;
      this.smoker = '0';
      this.glucoseAndCholesterolUnit = 'mg/dl';
      this.scaleAndTempUnit = 'IMPERIAL';
      this.userDetails.language = 'eng';
      this.heightInCm = null;
      this.birthdate = '';
      this.weightInKg = null;
      this.tab = null;
      this.valid = false;
      this.fileUpload = null;
      this.staffSelected = [];

      this.resetComponent();
      this.$store.commit('SET_DETAIL_DRAWER_STATE', false);
      this.$store.commit('SET_DETAILS_DRAWER', false);
    },
    async getPatients () {
      const hospitalIdFromStore = this.userData.hospitalAssignedData.id;
      if (this.roleName === 'HOSPITAL_ADMIN' || this.roleName === 'DOCTOR' || this.roleName === 'NURSE') {
        await this.$store.dispatch('hospitals/getRelatedPatientsV4', hospitalIdFromStore);
      } else if (this.roleName === 'ORGANIZATION_ADMIN') {
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
  },
  watch: {
    detailsDrawer: {
      deep: true,
      handler (newVal) {
        if (newVal) {
          this.initializeAddPatient();
          this.getSelectedLocation();
        } else {
          this.resetComponent();
        }
      },
    },
    async loader () {
      if (this.loader !== null) {
        const l = this.loader;
        this[l] = !this[l];

        await this.createPatient()
          .then(() => {
            this[l] = false;
          })
          .catch(() => {
            this[l] = false;
          });

        this.loader = null;
      }
    },
  },
};
</script>
